import {
	MasterFileLabListPage,
	MasterFileLabAddPage,
	MasterFileLabEditPage,
	MasterFileLabDetailPage,
} from "pages/AdminLaboratorium/MasterFileLab";
import {UserAttendanceMePage} from "pages/Attendance/UserAttendanceMe";

export const adminLaboratoriumRoutes = [
	{
		name: "admin-laboratoriun-master-file-lab",
		path: "/file-labs",
		exact: true,
		isPrivate: true,
		component: MasterFileLabListPage,
	},
	{
		name: "admin-laboratoriun-master-file-lab-add",
		path: "/file-labs/tambah",
		exact: true,
		isPrivate: true,
		component: MasterFileLabAddPage,
	},
	{
		name: "admin-laboratoriun-master-file-lab-edit",
		path: "/file-labs/edit/:id",
		exact: true,
		isPrivate: true,
		component: MasterFileLabEditPage,
	},
	{
		name: "admin-laboratoriun-master-file-lab-detail",
		path: "/file-labs/detail/:id",
		exact: true,
		isPrivate: true,
		component: MasterFileLabDetailPage,
	},
	{
		name: "absensi-staff",
		path: "/absensi-staff",
		exact: true,
		isPrivate: true,
		component: UserAttendanceMePage,
	},
];
